/**
 * Browser Notification Manager
 */
export const NotificationManager = {
  async requestPermission() {
    if (!('Notification' in window)) return false;
    if (Notification.permission === 'granted') return true;
    
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  },

  send(title: string, options?: NotificationOptions) {
    if (Notification.permission === 'granted') {
      new Notification(title, {
        icon: '/vite.svg',
        ...options
      });
    }
  },

  checkUpcomingEvents(countdowns: any[]) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    countdowns.forEach(event => {
      const eventDate = new Date(event.event_date);
      eventDate.setHours(0, 0, 0, 0);
      
      const diffDays = Math.ceil((eventDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
      
      if (diffDays === 1) {
        this.send(`Tomorrow: ${event.name}`, {
          body: `Don't forget! ${event.name} is happening tomorrow! ${event.emoji || '🎉'}`,
        });
      } else if (diffDays === 0) {
        this.send(`Today: ${event.name}`, {
          body: `The big day is here! ${event.name} is happening today! 🥳`,
        });
      }
    });
  }
};